<template>
  <li class="gfb-option-display">
    <component
      :is="config.icon"
      :weight="config.weight"
      :color="config.color"
      :class="config.iconClass"
      size="24px"
    />{{ text }}
  </li>
</template>

<script>
import {
  PhCheckCircle,
  PhXCircle,
  PhWarningCircle,
  PhInfo,
  PhMinusCircle,
} from "@phosphor-icons/vue"

const STATUS_CONFIG = {
  success: { icon: "PhCheckCircle", weight: "fill", color: "#10C95A" },
  fail: { icon: "PhXCircle", weight: "fill", color: "#B0B9C9" },
  warning: { icon: "PhWarningCircle", weight: "fill", color: "#525E77" },
  info: {
    icon: "PhInfo",
    weight: "duotone",
    iconClass: "gfb-option-display__icon--info",
  },
  missing: {
    icon: "PhMinusCircle",
    weight: "duotone",
    iconClass: "gfb-option-display__icon--missing",
  },
}

export default {
  name: "gfb-option-display",
  components: {
    PhCheckCircle,
    PhXCircle,
    PhWarningCircle,
    PhInfo,
    PhMinusCircle,
  },
  props: {
    status: {
      type: String,
      required: true,
      validator: (value) => Object.keys(STATUS_CONFIG).includes(value),
    },
    text: {
      type: String,
      required: true,
    },
  },
  computed: {
    config() {
      return STATUS_CONFIG[this.status]
    },
  },
}
</script>

<style lang="scss" scoped>
// PhInfo/PhMinusCircle's duotone weight only exposes a single `color` prop
// for both of their paths, so these two colors are set directly on each path.
.gfb-option-display {
  display: flex;
  align-items: center;

  svg {
    margin-right: 8px;
    flex-shrink: 0;
  }

  &__icon--info {
    :deep(path:nth-child(1)) {
      fill: #fbbc04;
    }

    :deep(path:nth-child(2)) {
      fill: #543f01;
    }
  }

  &__icon--missing {
    :deep(path:nth-child(1)) {
      fill: #ffffff;
    }

    :deep(path:nth-child(2)) {
      fill: #929394;
    }
  }
}
</style>
